// Reads UTM params + source page for lead attribution.
export function getUtm() {
  const p = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  const utm = {};
  let found = false;
  keys.forEach((k) => {
    const v = p.get(k);
    if (v) {
      utm[k] = v;
      found = true;
    }
  });
  return found ? utm : null;
}

export function getSourcePage() {
  return window.location.pathname || "/";
}
